import { LiveChatUIContent } from "./components/LiveChatUIContent";
import { LiveChatUIContentBody } from "./components/LiveChatUIContentBody";
import { LiveChatUIContentScrollable } from "./components/LiveChatUIContentScrollable";
import { LiveChatUIConversationList } from "./components/LiveChatUIConversationList";
import { LiveChatUIConversationListItem } from "./components/LiveChatUIConversationListItem";
import { LiveChatUILogo } from "./components/LiveChatUILogo";
import { LiveChatUIMessageList } from "./components/LiveChatUIMessageList";
import { LiveChatUIMessageListSkeleton } from "./components/LiveChatUIMessageListSkeleton";
import { LiveChatUIMobileTopBar } from "./components/LiveChatUIMobileTopBar";
import { LiveChatUIRoot } from "./components/LiveChatUIRoot";
import { LiveChatUISidebar } from "./components/LiveChatUISidebar";
import { LiveChatUISidebarButton } from "./components/LiveChatUISidebarButton";
import { LiveChatUISidebarDivider } from "./components/LiveChatUISidebarDivider";
import { LiveChatUISidebarSkeleton } from "./components/LiveChatUISidebarSkeleton";
import { LiveChatUIWelcomeContainer } from "./components/LiveChatUIWelcomeContainer";
import { LiveChatUIWelcomeHero } from "./components/LiveChatUIWelcomeHero";
import { LiveChatUIWelcomeSkeleton } from "./components/LiveChatUIWelcomeSkeleton";

export const LiveChatUI = {
  Root: LiveChatUIRoot,
  Logo: LiveChatUILogo,
  MobileTopBar: LiveChatUIMobileTopBar,

  Sidebar: LiveChatUISidebar,
  SidebarSkeleton: LiveChatUISidebarSkeleton,
  SidebarDivider: LiveChatUISidebarDivider,
  SidebarButton: LiveChatUISidebarButton,

  ConversationList: LiveChatUIConversationList,
  ConversationListItem: LiveChatUIConversationListItem,

  Content: LiveChatUIContent,
  ContentScrollable: LiveChatUIContentScrollable,
  ContentBody: LiveChatUIContentBody,

  WelcomeContainer: LiveChatUIWelcomeContainer,
  WelcomeHero: LiveChatUIWelcomeHero,
  WelcomeSkeleton: LiveChatUIWelcomeSkeleton,

  MessageList: LiveChatUIMessageList,
  MessageListSkeleton: LiveChatUIMessageListSkeleton,
};
